var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryAlcohol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4537 17.7103H36.5379V14.5432C36.5379 12.5013 34.9535 10.8414 33.0044 10.8414H15.5295C13.5805 10.8414 11.9961 12.5013 11.9961 14.5432V48.867H36.5312V42.005H38.4471C41.5894 42.005 44.1351 39.338 44.1351 36.0459V23.6624C44.1351 20.3703 41.5894 17.7033 38.4471 17.7033L38.4537 17.7103ZM40.1442 36.0529C40.1442 37.0183 39.3885 37.817 38.4604 37.817H36.5379V21.8983H38.4537C39.3819 21.8983 40.1442 22.697 40.1442 23.6694V36.0598V36.0529Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.79 18.1548H17.7304C17.1226 18.1548 16.6299 18.671 16.6299 19.3078V40.4007C16.6299 41.0374 17.1226 41.5536 17.7304 41.5536H17.79C18.3978 41.5536 18.8905 41.0374 18.8905 40.4007V19.3078C18.8905 18.671 18.3978 18.1548 17.79 18.1548Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3066 18.1548H24.247C23.6392 18.1548 23.1465 18.671 23.1465 19.3078V40.4007C23.1465 41.0374 23.6392 41.5536 24.247 41.5536H24.3066C24.9144 41.5536 25.4071 41.0374 25.4071 40.4007V19.3078C25.4071 18.671 24.9144 18.1548 24.3066 18.1548Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8174 18.1548H30.7577C30.1499 18.1548 29.6572 18.671 29.6572 19.3078V40.4007C29.6572 41.0374 30.1499 41.5536 30.7577 41.5536H30.8174C31.4251 41.5536 31.9178 41.0374 31.9178 40.4007V19.3078C31.9178 18.671 31.4251 18.1548 30.8174 18.1548Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79 47.6794V47.6863C10.79 48.3384 11.2946 48.867 11.917 48.867H36.6378C37.2602 48.867 37.7648 48.3384 37.7648 47.6863V47.6794C37.7648 47.0273 37.2602 46.4986 36.6378 46.4986H11.917C11.2946 46.4986 10.79 47.0273 10.79 47.6794Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5544 14.3557C17.0697 14.3557 19.1087 12.2195 19.1087 9.5843C19.1087 6.94911 17.0697 4.81287 14.5544 4.81287C12.0391 4.81287 10 6.94911 10 9.5843C10 12.2195 12.0391 14.3557 14.5544 14.3557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0726 13.8348C36.9362 13.8348 38.4469 12.252 38.4469 10.2996C38.4469 8.34721 36.9362 6.76447 35.0726 6.76447C33.209 6.76447 31.6982 8.34721 31.6982 10.2996C31.6982 12.252 33.209 13.8348 35.0726 13.8348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8669 13.8348C24.9864 13.8348 27.5151 11.1855 27.5151 7.91741C27.5151 4.64931 24.9864 2 21.8669 2C18.7475 2 16.2188 4.64931 16.2188 7.91741C16.2188 11.1855 18.7475 13.8348 21.8669 13.8348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7947 15.5017C31.9141 15.5017 34.4429 12.8524 34.4429 9.58428C34.4429 6.31618 31.9141 3.66687 28.7947 3.66687C25.6753 3.66687 23.1465 6.31618 23.1465 9.58428C23.1465 12.8524 25.6753 15.5017 28.7947 15.5017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7864 13.1055H27.7798C27.3038 13.1055 26.918 13.5098 26.918 14.0084V20.5231C26.918 21.0218 27.3038 21.426 27.7798 21.426H27.7864C28.2624 21.426 28.6482 21.0218 28.6482 20.5231V14.0084C28.6482 13.5098 28.2624 13.1055 27.7864 13.1055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7864 22.7873H27.7798C27.3038 22.7873 26.918 23.1915 26.918 23.6902V24.9681C26.918 25.4668 27.3038 25.871 27.7798 25.871H27.7864C28.2624 25.871 28.6482 25.4668 28.6482 24.9681V23.6902C28.6482 23.1915 28.2624 22.7873 27.7864 22.7873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0042 10.0635H20.9976C20.5216 10.0635 20.1357 10.4678 20.1357 10.9664V15.9254C20.1357 16.424 20.5216 16.8283 20.9976 16.8283H21.0042C21.4801 16.8283 21.866 16.424 21.866 15.9254V10.9664C21.866 10.4678 21.4801 10.0635 21.0042 10.0635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8078",
    x: 8,
    y: 0,
    width: 38.1348,
    height: 50.867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8078",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryAlcohol);
export default __webpack_public_path__ + "static/media/category_alcohol.1c5e590f35d6b6025d7c42d4603feeb1.svg";
export { ForwardRef as ReactComponent };